import type { FunctionComponent } from "react"

import { useEffect } from "react"

import IconCross from "@jobteaser/ui-kit/assets/icons/jds_cross.svg"
import { Icon, ICON_SIZES } from "@jobteaser/ui-kit/components/Icon/Icon"
import { TEXT_TYPES } from "@jobteaser/ui-kit/components/Text/Text"
import { TextWithDangerouslyInnerHtml } from "@jobteaser/ui-kit/components/Text/TextWithDangerouslyInnerHtml"

import {
  NOTIFICATION_BANNER_DATA_TESTID,
  NOTIFICATION_BANNER_DISPLAYED_EVENT,
  NOTIFICATION_BANNER_ID,
} from "@/modules/notificationBanner/constants"

import styles from "./NotificationBanner.module.css"

type NotificationBannerProps = {
  text: string
  onClose: () => void
}

export const NotificationBanner: FunctionComponent<NotificationBannerProps> = ({ text, onClose }) => {
  useEffect(() => {
    window.dispatchEvent(new CustomEvent(NOTIFICATION_BANNER_DISPLAYED_EVENT))
  }, [])

  return (
    <div
      className={styles.main}
      id={NOTIFICATION_BANNER_ID}
      data-testid={NOTIFICATION_BANNER_DATA_TESTID}
      role="status"
      aria-live="polite"
      aria-atomic="true"
    >
      <TextWithDangerouslyInnerHtml tag="div" resetSpacing className={styles.text} type={TEXT_TYPES.NORMAL}>
        {text}
      </TextWithDangerouslyInnerHtml>
      <button type="button" className={styles.button} onClick={onClose}>
        <Icon xlinkHref={`#${IconCross.id}`} size={ICON_SIZES.BIG} />
      </button>
    </div>
  )
}
